import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";

export const StyledListContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    overflowY: "auto",
}));
